<template>
  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Vendas por Vendedor {{data_inicio_cabecalho }} até {{data_fim_cabecalho }}</h4>
          </div>

          <div class="row">
            <p class="bg-warning btn-round text-white col-md-12" id="error_data" style="display:none">A data selecionada não é uma data valida</p>
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_inicio)" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_fim)" v-model="data_fim">
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>
          <div class="mb-3">
            <div v-for="vendedor of vendas" class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-6">
                <strong>{{ vendedor.nome }}</strong>
              </div>
              <div class="col-6 text-right">
                <strong>Qtd: {{ vendedor.vendas }}</strong>                
              </div>
              <div class="col-6">
                Custo
                <br>
                Faturado
                <br>
                Comissão
                <span style="color: #888; font-size: 10px;">{{ vendedor.data | moment("DD/MM/YYYY") }} {{ vendedor.hora }}</span>
              </div>
              <div class="col-6 text-right">
                {{ vendedor.custo | currencyBrl(true) }}
                <br>
                {{ vendedor.faturado | currencyBrl(true) }}
                <br>
                {{ vendedor.comissao | currencyBrl(true) }}
              </div>
            </div>

            <div class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-5">
                <strong>Custo:</strong>
                <br>
                <strong>Faturado:</strong>
                <br>
                <strong>Comissão:</strong>
              </div>
              <div class="col-7 text-right">
                <strong>{{ total.custo | currencyBrl(true) }}</strong>
                <br>
                <strong>{{ total.faturado | currencyBrl(true) }}</strong>
                <br>
                <strong>{{ total.comissao | currencyBrl(true) }}</strong>
              </div>
            </div>
          </div>

          <table class="table table-striped hidden-mobile">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Vendas</th>
                <th>Qtd. Itens</th>
                <th>Custo</th>
                <th>Faturado</th>
                <th>Comissão</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="vendedor of vendas">
                <td>{{ vendedor.nome }}</td>
                <td>{{ vendedor.vendas }}</td>
                <td>{{ vendedor.vendas_itens }}</td>
                <td>{{ vendedor.custo | currencyBrl(true)}}</td>
                <td>{{ vendedor.faturado | currencyBrl(true)}}</td>
                <td>{{ vendedor.comissao | currencyBrl(true)}}</td>
              </tr>
              <tr v-if="!vendas">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                <td>{{ total.qtd }}</td>
                <td>{{ total.qtd_itens }}</td>
                <td>{{ total.custo | currencyBrl(true) }}</td>
                <td>{{ total.faturado | currencyBrl(true) }}</td>
                <td>{{ total.comissao | currencyBrl(true) }}</td>
              </tr>              
            </tfoot> 
          </table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
    AnimatedNumber,
  } from 'src/components'
import { setInterval } from 'timers';
import moment from 'moment'
import jQuery from 'jquery'
import GlobalFunctions from '../../../globalFunctions.js'
import VendaService from '@/services/VendaService.js'
export default {
    components: {
      Card,
      AnimatedNumber,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_inicio_cabecalho: moment().format("DD/MM/YYYY"),
        data_fim_cabecalho: moment().format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(),
        vendas: null,
        current_page: 1,
        pageCount: 0,
        total:0,
      }
    },
    methods:{
      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadVendas()
      },
      loadVendas() {
        VendaService.loadPorVendedores(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}`).then(res => {
          this.total = res.data.total;
          this.vendas = res.data.data;
        }).catch(err => {
          console.log(e)
        })
      },
      verificaData(data) {
        let data_formatada = new Date(data);
        if(data_formatada == 'Invalid Date'){
          jQuery('#error_data').show();
        }else{
          jQuery('#error_data').hide();
        }
      },

      changePage(page) {
        this.current_page = page
        this.loadVendas()
      },

    },
    mounted() {
      this.loadVendas()
    }
}
</script>